import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ke,
  r as r2
} from "./chunk.WKUNRGJV.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/icons/jb-checkmark-icon/jb-checkmark-icon.scss?inline
var jb_checkmark_icon_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

*:focus-visible {
  outline-color: rgb(var(--theme-color-signal-blue, 0 37 255));
  outline-offset: 6px;
  outline-style: var(--focus-outline-style, auto);
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
/* special measurements */
:host {
  color: var(--host-color, #141e55);
}`;

// src/components/icons/jb-checkmark-icon/jb-checkmark-icon.ts
var JbCheckmarkIcon = class extends r2 {
  render() {
    return ke`
      <svg
        width="18"
        height="18"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.6012 12.4013C8.27526 12.7273 7.74686 12.7272 7.42095 12.4013L3.94464 8.92478C3.61873 8.59885 3.6187 8.07041 3.94464 7.74446C4.27057 7.4185 4.79897 7.41853 5.12488 7.74446L8.01107 10.6308L12.8971 5.74446C13.2231 5.4185 13.7515 5.41853 14.0774 5.74446C14.4033 6.07038 14.4033 6.59882 14.0774 6.92478L8.6012 12.4013Z"
          fill="var(--host-color, currentColor)"
        />
      </svg>
    `;
  }
};
JbCheckmarkIcon.styles = r(jb_checkmark_icon_default);
JbCheckmarkIcon = __decorateClass([
  customElement("jb-checkmark-icon")
], JbCheckmarkIcon);

export {
  JbCheckmarkIcon
};
